export var ApplicationType;
(function (ApplicationType) {
    ApplicationType[ApplicationType["NEW"] = 1] = "NEW";
    ApplicationType[ApplicationType["EXTENSION"] = 2] = "EXTENSION";
})(ApplicationType || (ApplicationType = {}));
export var DisplayApplicationType;
(function (DisplayApplicationType) {
    DisplayApplicationType["NEW"] = "NEW";
    DisplayApplicationType["EXTENSION"] = "EXTENSION";
})(DisplayApplicationType || (DisplayApplicationType = {}));
export const ApplicationTypeTranslation = {
    [DisplayApplicationType.EXTENSION]: 'Przedłużenie aktywności karty o rok',
    [DisplayApplicationType.NEW]: 'Wydanie nowej karty'
};
export var ApplicationState;
(function (ApplicationState) {
    ApplicationState[ApplicationState["SUBMITTED"] = 1] = "SUBMITTED";
    ApplicationState[ApplicationState["ACCEPTED"] = 200] = "ACCEPTED";
    ApplicationState[ApplicationState["REJECTED"] = 400] = "REJECTED";
})(ApplicationState || (ApplicationState = {}));
export var DisplayApplicationState;
(function (DisplayApplicationState) {
    DisplayApplicationState["SUBMITTED"] = "SUBMITTED";
    DisplayApplicationState["ACCEPTED"] = "ACCEPTED";
    DisplayApplicationState["REJECTED"] = "REJECTED";
})(DisplayApplicationState || (DisplayApplicationState = {}));
export const ApplicationStateTranslation = {
    [DisplayApplicationState.SUBMITTED]: 'Złożony',
    [DisplayApplicationState.ACCEPTED]: 'Zaakceptowany',
    [DisplayApplicationState.REJECTED]: 'Odrzucony'
};
export const ApplicationStateMultipleTranslation = {
    [DisplayApplicationState.SUBMITTED]: 'Złożone',
    [DisplayApplicationState.ACCEPTED]: 'Zaakceptowane',
    [DisplayApplicationState.REJECTED]: 'Odrzucone'
};
//# sourceMappingURL=application.enum.js.map